<flx-modal
  [dismissible]="true"
  (dismiss)="closeModal()"
  class="flx-ds medium"
  data-testid="build-modal"
>
  <div
    class="flx-modal-title"
    flxModalHeaderTitle
  >
    {{ title }}
  </div>
  <div
    class="flx-modal-subtitle"
    flxModalHeaderSubtitle
  >
    {{ subtitle }}
  </div>

  <div
    [formGroup]="tagBuildFG"
    (submitForm)="tagBuild()"
    class="flx-modal-body"
    flxEnterSubmitForm
  >
    <div class="flex gap-x-8">
      <flx-input class="flx-ds w-1/2">
        <flx-label class="flx-ds">Name</flx-label>
        <input
          [formControl]="appTitleFG"
          flxInput
        />
      </flx-input>
      <flx-input
        [isInvalid]="majorFc.invalid"
        class="flx-ds flex-1 min-w-0"
      >
        <flx-label class="flx-ds mandatory">Major</flx-label>

        <input
          [class.has-error]="majorFc.invalid"
          [formControl]="majorFc"
          class="w-full"
          data-testId="major-version-input"
          flxAutofocus
          flxInput
          placeholder="0"
          type="number"
        />

        @if (majorFc.errors?.required) {
          <flx-error>Major is required</flx-error>
        } @else if (majorFc.errors) {
          <flx-error
            >Major must be a number greater than or equal to 0, smaller then MAX INT</flx-error
          >
        }
      </flx-input>

      <flx-input
        [isInvalid]="minorFc.invalid"
        class="flx-ds flex-1 min-w-0"
      >
        <flx-label class="flx-ds mandatory">Minor</flx-label>

        <input
          [class.has-error]="minorFc.invalid"
          [formControl]="minorFc"
          class="w-full"
          data-testId="minor-version-input"
          flxInput
          placeholder="0"
          type="number"
        />

        @if (minorFc.errors?.required) {
          <flx-error>Minor is required</flx-error>
        } @else if (minorFc.errors) {
          <flx-error
            >Minor must be a number greater than or equal to 0, smaller then MAX INT</flx-error
          >
        }
      </flx-input>

      <flx-input
        [isInvalid]="tagBuildFG.controls.patch.invalid"
        class="flx-ds flex-1 min-w-0"
      >
        <flx-label class="flx-ds mandatory">Patch</flx-label>

        <input
          [class.has-error]="patchFc.invalid"
          [formControl]="patchFc"
          class="w-full"
          placeholder="0"
          flxInput
          type="number"
          data-testId="patch-version-input"
        />

        @if (patchFc.errors?.required) {
          <flx-error>Patch is required</flx-error>
        } @else if (patchFc.errors) {
          <flx-error
            >Patch must be a number greater than or equal to 0, smaller then MAX INT</flx-error
          >
        }
      </flx-input>
    </div>
  </div>

  <div class="flx-modal-footer">
    <div class="flx-modal-footer__right">
      <button
        (click)="closeModal()"
        class="flx-ds secondary"
        data-testId="cancel-button"
        flxButton
        type="button"
        variant="ghost"
      >
        Cancel
      </button>
      <button
        [disabled]="disableSubmitButton"
        (click)="tagBuild()"
        class="flx-ds primary"
        data-testId="save-button"
        flxButton
        type="button"
      >
        Save
      </button>
    </div>
  </div>
</flx-modal>
